import { render, staticRenderFns } from "./resumesix_template.vue?vue&type=template&id=4806de96&scoped=true&"
import script from "./resumesix_template.vue?vue&type=script&lang=js&"
export * from "./resumesix_template.vue?vue&type=script&lang=js&"
import style0 from "./resumesix_template.vue?vue&type=style&index=0&id=4806de96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806de96",
  null
  
)

export default component.exports